import React, { Component } from "react";
import "./App.css";
import "react-toastify/dist/ReactToastify.css";

import * as actions from "./store/actions";
import { connect } from "react-redux";
import { Routes, Route } from "react-router-dom";
import { ToastContainer } from "react-toastify";

import Login from "./components/Login/Login";
import PrivateRoute from "./containers/Routes/PrivateRoute";
import Layout from "./components/Layout/Layout";
import Spinner from "./containers/UI/Spinner/Spinner";

class App extends Component {
  componentDidMount() {
    this.props.onTryAutoSignup();
  }

  render() {
    let { loadingCheck } = this.props;

    if (loadingCheck) {
      return (
        <div className="rootLoading">
          <Spinner />
        </div>
      );
    }
    return (
      <div className="App">
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/*" element={<PrivateRoute><Layout /></PrivateRoute>} />
        </Routes>
        <ToastContainer autoClose={3000} />
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    loadingCheck: state.auth.loadingCheck
  };
};

const mapDispatchToProps = dispatch => {
  return {
    onTryAutoSignup: () => dispatch(actions.checkAuthStatus())
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(App);
